BookingMovements.$inject = [
    'Club',
    'User',
    'CreateCashMovementModal',
    'alerts',
    'Time',
    'Backoffice',
];

function BookingMovements(
    Club,
    User,
    CreateCashMovementModal,
    alerts,
    Time,
    Backoffice,
) {
    return {
        restrict: 'E',
        link: link,
        scope: {
            booking: '=',
            date: '=',
        },
        template: require('../../views/booking/booking.movements.directive.html'),
    };

    function link($scope, element, attrs) {
        getMovements($scope);

        $scope.registerMovement = (type, booking) => {
            var start = booking.attrs.start;
            if (booking.bookeable.datetime_start) {
                var booking_date = booking.bookeable.datetime_start + ':00';
            } else {
                var datetime = Time.moment($scope.date);
                datetime.hour(start.hour);
                datetime.minute(start.min);
                var booking_date = datetime.format('YYYY-MM-DD HH:mm:ss');
            }

            CreateCashMovementModal.open(
                {
                    type,
                    booking_id: booking.id,
                    datetime,
                    court: booking.court.name,
                    booking_date,
                    player: booking.attrs.user.name,
                    fixed: booking.attrs.fixed,
                    user: User.data.name,
                },
                {
                    onUpdated: () => {
                        getMovements($scope);
                    },
                },
            );
        };

        $scope.editMovement = (movement, booking = null) => {
            return CreateCashMovementModal.open(
                {
                    ...movement,
                    player: booking.attrs.user.name,
                    court: booking.court.name,
                },
                {
                    onUpdated: () => {
                        getMovements($scope);
                    },
                },
            );
        };

        $scope.deleteMovement = async (movement, booking = null) => {
            try {
                const {code , user_info} = await alerts.verifyCode(null, null, User);
                const created_by = {
                    user: user_info?.name ?? User.data.name,
                    player: booking.attrs.user.name,
                };
                const concept_details = {
                    booking_date: new Date(movement.datetime).toISOString(),
                    court: booking.court.name,
                    booking_id: movement.booking_id,
                };

                if (movement.payed) {
                    var cash_movement_result =
                        await Backoffice.api.registerCashMovement({
                            value: -(movement.value * 100) * movement.quantity,
                            concept: `Borrado manual de consumo - ${movement.concept}`,
                            payment_method: movement.payment_type,
                            created_by: JSON.stringify(created_by),
                            movement_datetime: new Date().toISOString(),
                            concept_details: JSON.stringify(concept_details),
                            quantity: movement.quantity,
                            item_id: movement.item_id,
                        });
                }
                var stock_movement_result =
                    await Backoffice.api.registerStockMovement({
                        item_id: movement.item_id,
                        value: movement.quantity,
                    });

                try {
                    await Club.CashMovementsAPI.one(
                        'general',
                        movement.id,
                    ).remove({
                        code: code,
                    });
                } catch (error) {
                    await Backoffice.api.undoRegisterCarts({
                        cash_movements: cash_movement_result
                            ? [{ id: cash_movement_result.id }]
                            : [],
                        stock_movements: [{ id: stock_movement_result.id }],
                    });

                    throw new Error(
                        'A ocurrido un error inesperado. Intente nuevamente',
                    );
                }
                $scope.movements = $scope.movements.filter(
                    (item) => item.id !== movement.id,
                );
                alerts.success(
                    'Exito!',
                    'El consumo fue borrado correctamente',
                    {
                        timeout: 3,
                    },
                );
                return;
            } catch (error) {
                alerts.error('Error', error.message);
            } finally {
                this.loading = false;
            }
        };
    }

    function getMovements($scope) {
        $scope.movements_loading = true;
        Club.API.one('booking', $scope.booking.id)
            .customGET('movements', { date: $scope.date.format('YYYY-MM-DD') })
            .then(function (movements) {
                $scope.movements = movements;
                $scope.movements_total = movements.reduce(
                    (sum, item) =>
                        sum +
                        parseFloat(item.value) * parseFloat(item.quantity),
                    0,
                );
            })
            .catch(angular.noop)
            .finally(function () {
                $scope.movements_loading = false;
            });
    }
}

export default BookingMovements;
